// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"88558ded","703":"33b1a793"}[chunkId] + ".chunk.js";
};